import { API as GeneratedAPI, type ApiConfig } from "@/api/generated/Api";

export * from "@/api/generated/Api";

export class API<
  SecurityDataType = unknown,
> extends GeneratedAPI<SecurityDataType> {
  constructor(config: ApiConfig<SecurityDataType> = {}) {
    super({
      baseURL: import.meta.env.VITE_API_URL,
      paramsSerializer: { indexes: null },
      ...config,
    });
  }
}
